import { SortDirection } from '../../components/table/sortable-header';
import { positiveInteger } from '../../lib/url/hooks/use-queries-control';

export const createCollectionParamParser = () => {
	return [
		['pageNumber', 'sortBy', 'sortDirection', 'countryCode'],
		{
			defaultValue: {
				// TODO: Look at updating this to the company country?
				countryCode: 'US',
				pageNumber: '1',
				sortBy: 'name',
				sortDirection: SortDirection.ASC,
			},
			allowedValues: {
				sortBy: ['name'],
				sortDirection: [SortDirection.ASC, SortDirection.DESC],
			},
			transforms: {
				pageNumber: positiveInteger,
			},
		},
	] as const;
};
